import { RootState } from '../store';

export const getAuthState = (state: RootState) => state.authentication.authState;

export const getExpiresAt = (state: RootState) => state.authentication.expiresAt;
